import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { BusStopsComponent } from './busstops.component';
import { BusStopsFiltersComponent } from './busstops-filters/busstops-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    BusStopsFiltersComponent,
    ListService
  ],
  declarations: [
    BusStopsComponent,
    BusStopsFiltersComponent
  ],
  exports: [
    BusStopsComponent
  ]
})

export class BusStopsModule { }
